import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { LogIn } from "lucide-react";

export default function LoginModal() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => {
      // Don't show modal if user is already logged in (has session in localStorage)
      try {
        const user = localStorage.getItem("markeemix_user");
        if (user && JSON.parse(user)?.user_id) {
          // User is logged in, don't show modal - just silently ignore
          return;
        }
      } catch (e) {}
      setOpen(true);
    };
    window.addEventListener("app:auth-required", handler);
    return () => window.removeEventListener("app:auth-required", handler);
  }, []);

  const goLogin = () => {
    setOpen(false);
    navigate("/login");
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md" data-testid="login-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl">
            <LogIn className="w-5 h-5 text-violet-600" /> Sign in required
          </DialogTitle>
          <DialogDescription>
            Please log in or create a free account to use this tool.
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-3 mt-4">
          <Button onClick={goLogin} className="flex-1 bg-violet-600 hover:bg-violet-700" data-testid="login-modal-signin">
            Sign In
          </Button>
          <Button variant="outline" onClick={() => { setOpen(false); navigate("/register"); }} className="flex-1" data-testid="login-modal-register">
            Create Account
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
